import styled from 'styled-components';
import { Button, ButtonIcon } from '@cubeyou-team/hx-react-components';

export const StyledAudiencesToComparePanel = styled.div`
  min-height: 100px;
  width: calc(100vw - 45px);
  right: ${props => props.theme.spacing.xlarge};
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: white;
  top: calc(100% - 160px);
  z-index: 9999;
  border: 2px solid rgb(216, 215, 234);
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const StyledSelectedItem = styled.div`
  height: 56px;
  border: 2px solid ${props => props.color};
  border-radius: 4px;
  padding: 0px 16px;
  display: flex;
  align-items: center;
  &:hover {
    border-color: ${props => props.color};
    background-color: ${props => `${props.color}33`};
  }
`;

export const StyledButtonIcon = styled(ButtonIcon)`
  & path {
    fill: ${props => props.color};
  }
`;

export const StyledButton = styled(Button)`
  color: ${props => !props.disabled && props.theme.colors.green};
  border-color: ${props => !props.disabled && props.theme.colors.green};

  &:hover {
    color: ${props => !props.disabled && props.theme.colors.light};
    background-color: ${props => !props.disabled && props.theme.colors.green};
  }
`;
